import { render, staticRenderFns } from "./zpindex.vue?vue&type=template&id=9b8c31d4&scoped=true&"
import script from "./zpindex.vue?vue&type=script&lang=js&"
export * from "./zpindex.vue?vue&type=script&lang=js&"
import style0 from "./zpindex.vue?vue&type=style&index=0&id=9b8c31d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c31d4",
  null
  
)

export default component.exports